import { Language } from '../constants/languages';
export const TABLE_TRANSLATION_KEYS = {
  closeButtonLabel: 'component.Table.Row.closeLabel'
};
export const TABLE_TRANSLATIONS = {
  [Language.EN]: {
    [TABLE_TRANSLATION_KEYS.closeButtonLabel]: 'Fold details'
  },
  [Language.PL]: {
    [TABLE_TRANSLATION_KEYS.closeButtonLabel]: 'Zwiń szczegóły'
  },
  [Language.SK]: {
    [TABLE_TRANSLATION_KEYS.closeButtonLabel]: 'Zbaliť detaily'
  },
  [Language.CS]: {
    [TABLE_TRANSLATION_KEYS.closeButtonLabel]: 'Sbalit detaily'
  }
};
export const TableHeadCellAlignment = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};
export const TableBackgroundColorVariant = {
  GRAY: 'GRAY',
  WHITE: 'WHITE',
  BLACK: 'BLACK',
  ZEUS_BLACK: 'ZEUS_BLACK'
};